/* eslint-disable @typescript-eslint/no-explicit-any */
import { post } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import Definitions from '../Definitions';
import { DocumentValueType } from '../Types/CommonTypes';

export type RecoverMemberNumberRequestType = {
  /** EMAIL principal em caso de nao ter CPF */
  email?: string;
  /** Documento CPF */
  document?: DocumentValueType;
  /** Data de Nascimento */
  birthDate: string;
  /** Recaptcha Google V2 */
  recaptcha?: {
    responseToken?: string;
  };
};

const definitions = Definitions.RecoverMemberNumber;

const callPost = async (
  params: RecoverMemberNumberRequestType,
): Promise<IFinalResponse> => {
  const init: InitApiType = {
    body: {
      ...params,
    },
  };
  return post(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { post: callPost };

export default { call, definitions };
